module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_aplus-c39f6e8fc305e0a7a7611cd7df9ba257.png";